import { Popover, Typography } from '@mui/material';
import { teaserImportanceTranslations } from '@nodeTypeConfig/PRO/proNews/TEASER';
import type React from 'react';
import { useState } from 'react';
import type { TeaserImportance } from '../AsideTeaserImportance';

const AsideTeaserImportanceLabel: React.FC<{ importance: TeaserImportance }> = ({ importance }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  if (importance === 'HIGH') {
    return (
      <>
        <span style={{ marginRight: '.5rem' }}>{teaserImportanceTranslations[importance]}</span>
        <sup>
          <span
            className="glyphicon glyphicon-question-sign"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
          />
        </sup>

        <Popover
          id="mouse-over-popover"
          sx={{
            pointerEvents: 'none',
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          disableRestoreFocus
        >
          <Typography sx={{ p: 1 }}>
            iedereen zal die deze teaser ontvangen in de nieuwsbrief, ook als ze niet ingeschreven
            zijn op jouw thema
          </Typography>
        </Popover>
      </>
    );
  }

  return teaserImportanceTranslations[importance];
};

export default AsideTeaserImportanceLabel;
